<template>
  <doughnut :chartdata="chartdata"/>
</template>

<script>
import Doughnut from '@/components/charts/doughnut'

export default {
  name: 'BackupSummaryPie',
  components: {
    Doughnut
  },
  props: {
    shelvery: {
      type: Number,
      default: () => 0
    },
    automated: {
      type: Number,
      default: () => 0
    },
    manual: {
      type: Number,
      default: () => 0
    },
    awsbackup: {
      type: Number,
      default: () => 0
    }
  },
  data () {
    return {
      chartdata: null
    }
  },
  methods: {
    fillchartdata: function () {
      this.chartdata = {
        labels: [
          'shelvery',
          'automated',
          'manual',
          'awsbackup'
        ],
        datasets: [
          {
            label: 'shelvery',
            backgroundColor: ['#06d6a0', '#ffd166', '#ef476f', '#118ab2'],
            data: [this.shelvery, this.automated, this.manual, this.awsbackup]
          }
        ]
      }
    }
  },
  created: function () {
    this.fillchartdata()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/charts/BackupSummaryPie.vue